var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Steeper/02 Email Verfication") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19.9999 0 19.9999 16.1 0 16.1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Steeper/02-Email-Verfication",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4248,9.3304 L13.8858,13.8704 L11.9428,11.9264 C11.5828,11.5644 10.9958,11.5664 10.6378,11.9264 C10.2778,12.2864 10.2778,12.8724 10.6378,13.2324 L13.2328,15.8294 C13.4078,16.0034 13.6398,16.1004 13.8858,16.1004 C14.1328,16.1004 14.3638,16.0034 14.5388,15.8294 L19.7298,10.6364 C20.0898,10.2764 20.0898,9.6904 19.7298,9.3304 C19.3718,8.9704 18.7838,8.9684 18.4248,9.3304",
    id: "Fill-1",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5729,6.118 L4.0899,1.998 L16.1729,1.998 L10.5729,6.118 Z M19.2289,1.007 C19.2259,1.003 19.2259,0.999 19.2229,0.995 C19.2179,0.988 19.2109,0.986 19.2059,0.979 C18.6569,0.381 17.8769,0 17.0019,0 L2.9979,0 C2.2339,0 1.5449,0.294 1.0149,0.765 C1.0129,0.766 1.0109,0.769 1.0079,0.77 C0.3939,1.319 -0.0001,2.109 -0.0001,2.998 L-0.0001,13.102 C-0.0001,14.758 1.3429,16.1 2.9979,16.1 L9.1479,16.1 C9.6999,16.1 10.1469,15.653 10.1469,15.101 C10.1469,14.549 9.6999,14.102 9.1479,14.102 L2.9979,14.102 C2.4459,14.102 1.9989,13.654 1.9989,13.102 L1.9989,3.037 L10.0779,8.171 C10.2419,8.276 10.4289,8.328 10.6139,8.328 C10.8229,8.328 11.0309,8.262 11.2059,8.133 L18.0009,3.135 L18.0009,7.136 C18.0009,7.688 18.4479,8.135 19.0009,8.135 C19.5529,8.135 19.9999,7.688 19.9999,7.136 L19.9999,2.998 C19.9999,2.23 19.7029,1.538 19.2289,1.007 L19.2289,1.007 Z",
    id: "Fill-3",
    fill: "current"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupStep2);
export default __webpack_public_path__ + "static/media/signup-step-2.96fe290d03e9b5d11b013cc781560158.svg";
export { ForwardRef as ReactComponent };